var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-results"},[_c('VText',{attrs:{"component":"p","variant":"h5","gutter-bottom":""}},[_vm._v("Nothing to show here")]),_vm._v(" "),_c('VText',[_vm._v("Check back in tomorrow")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }